require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-a-retailers-review-of-not-on-the-high-street.json") })
        }
      }, "path---blog-a-retailers-review-of-not-on-the-high-street");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-a-retailers-review-of-not-on-the-high-street!./.cache/json/blog-a-retailers-review-of-not-on-the-high-street.json
// module id = 424
// module chunks = 231608221292675